import { Store } from '@betgames/bg-state-manager';
import { IMessageQueueModel } from './interfaces/IMessageQueueModel';

export default class MessagesQueueStore extends Store<IMessageQueueModel[]> {
    private timeouts: Map<number | string, number> = new Map();

    constructor() {
        super({
            key: 'MessageQueue',
            default: [],
        });
    }

    private remove(id: number | string): void {
        this.update((state) => state.filter((message) => message.id !== id));

        clearTimeout(this.timeouts.get(id));
        this.timeouts.delete(id);
    }

    public add(message: IMessageQueueModel): void {
        this.update((state) => [...state, message]);

        this.timeouts.set(
            message.id,
            setTimeout(() => this.remove(message.id), message.timeout),
        );
    }

    public resetMessages(): void {
        this.reset();
        this.timeouts.forEach((timeout) => clearTimeout(timeout));
        this.timeouts.clear();
    }
}
